import React from "react";
import "./AP.scss";

import kiriatas from "../../Media/AbouProduk/Kiri Atas.webp";
import kiribawah from "../../Media/AbouProduk/Kiri Bawah.webp";
import kananatas from "../../Media/AbouProduk/Kanan Atas.webp";
import kananbawah from "../../Media/AbouProduk/Kanan Bawah.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SecondHero = () => {
  return (
    <div className="secondherocontainerAP" id="residential">
      <div className="secondmiddle">
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
        <div className="leftcontent">
          <div className="content-judul">
            <h1>Our Residential</h1>
            <h2>Luxury Within Reach </h2>
          </div>
          <div className="contentdescription">
            Wujudkan hunian impian anda dengan konsep rumah modern di kota
            mandiri Summarecon Serpong, kawasan strategis dengan fasilitas
            lengkap. Cocok untuk keluarga masa kini dan investasi properti
            jangka panjang yang menguntungkan.
          </div>
          <div className="container-benefit">
            <div className="benefit-list">
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Swimming Pool
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Fitness Center
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Jogging Track
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;Children Playground
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#576F66" />
                <span style={{color: "rgba(42, 42, 42, 1)"}}>
                  &nbsp;&nbsp;One Gate System & Security 24 Hours
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
